import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDefined, IsEnum, IsNumber, IsOptional, ValidateNested } from "class-validator";
import { MaxAppointedNhs } from "common/validators";
import { HTTP_VERBS } from "../../enums";
import { NhsDetailsDtoV2 } from "../domainObjects/acpDraft";
import { AcpNhsStatus } from "../enums";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v3/acp/nhs-renomination";

export class NhsDetailsDtoWithStatus extends NhsDetailsDtoV2 {
	@IsOptional({ always: true })
	@IsEnum(AcpNhsStatus)
	status?: AcpNhsStatus;

	@IsBoolean()
	@IsDefined()
	isAppointed!: boolean;
}
export class Body {
	@IsNumber()
	id!: number;

	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => NhsDetailsDtoWithStatus)
	@MaxAppointedNhs({ always: true })
	spokesPersons!: NhsDetailsDtoWithStatus[];
}
export class Response {}
